/* eslint-disable no-duplicate-imports  */
import { isBoolean, isObject } from 'lodash';
import stringifyObject from 'stringify-object';
export function attributesToString(
  data: any,
  options: {
    ignoreUndefined?: boolean;
  } = {},
): string {
  return Object.keys(data).reduce((acc, key) => {
    if (options.ignoreUndefined && data[key] === undefined) {
      return '';
    }

    const value = data[key] === null ? '' : data[key];
    const dataToString =
      Array.isArray(value) || isBoolean(value) || isObject(value)
        ? stringifyObject(value, {
            singleQuotes: false,
            inlineCharacterLimit: 1024,
            filter: (o, p) => (options.ignoreUndefined ? o[p] !== undefined : true),
          })
        : `"${value}"`;
    return `${acc}${key} : ${dataToString} `;
  }, '');
}
export const retryCall = async (args: {
  fn: () => any;
  attempts: number;
  needRetry: (arg0: any) => boolean;
  delayBetweenCall: number;
}) => {
  const { fn, attempts, needRetry, delayBetweenCall = 0 } = args;
  const response = await new Promise((resolve) => {
    setTimeout(() => resolve(fn()), delayBetweenCall);
  });
  const remainingAttemps = attempts - 1;

  if (remainingAttemps && needRetry(response)) {
    return retryCall({ ...args, attempts: remainingAttemps });
  }

  return response;
};
